import React from "react";
import { Modal } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";

function PaymentModal({ show, handleClose, title, message, isSuccess }) {
	const navigate = useNavigate();
	return (
		<Modal show={show} className="payment-modla" onHide={handleClose} centered>
			<Modal.Body>
				<h2>{title}</h2>
				<p>{message}</p>
				{/* {isSuccess && (
					<Link
						to="/account"
						className="modal_button"
						onClick={() => {
							// dispatch(setIsOpenRightMenu(false));
						}}>
						Личный кабинет
					</Link>
				)} */}
			</Modal.Body>
		</Modal>
	);
}

export default PaymentModal;
